import React, { useEffect, useState } from "react";
import { RootState } from "../../../redux/rootReducers";
import { connect } from "react-redux";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
} from "../../../components/commons";
import ReceiptAndPaymentHeader from "../../../components/Reports/ReceiptAndPayment/ReceiptAndPaymentHeader";
import { resetSession } from "../../../redux/auth";
import {
  getReceiptAndPaymentReportAction,
  resetReceiptAndPayment,
  resetReportsError,
  resetReportsSuccess,
} from "../../../redux/reports";
import {
  formatDate,
  handleDate,
  reverseDateFormat,
} from "../../../utils/commonFunctions";
import { BalanceSheetImage } from "../../../assets/images";
import  { Toaster } from "react-hot-toast";
import SkeltonElement from "../../../components/commons/BoxLoader/SkeltonElement";
import { GetReceiptAndPaymentReportsPayloadType } from "../../../commonTypes/reportsTypes";
import ReceiptAndPaymentReceiptTable from "../../../components/Reports/ReceiptAndPayment/ReceiptAndPaymentReceiptTable/ReceiptAndPaymentReceiptTable";
import { ReceiptAndPaymentType } from "../../../redux/reports/reportsType";
import { RECEIPT_AND_PAYMENT_HEADERS } from "../../../constant/tableHeadersConstants/reportsConstant/ReceiptAndPaymentConstant/reseiptAndPaymentHeadersConst";
import ReceiptAndPaymentPaymentTable from "../../../components/Reports/ReceiptAndPayment/ReceiptAndPaymentPaymentTable/ReceiptAndPaymentPaymentTable";

type AppProps = {
  history: any;
  token: string | null;
  fetching: boolean;
  error: string | null;
  success: number | null;
  statusCode: number | null;
  currencySign: string | undefined;
  clientCompanyName: string;
  dispatchResetSession: () => void;
  dispatchResetReportsErrorAction: () => void;
  dispatchResetReportsSuccessAction: () => void;
  dispatchGetReceiptAndPaymentReportAction: (
    data: GetReceiptAndPaymentReportsPayloadType
  ) => void;
  receiptAndPaymentData: ReceiptAndPaymentType | any;
  dispatchResetReceiptAndPaymentReportAction: () => void;
};

const ReceiptAndPayment = ({
  history,
  clientCompanyName,
  token,
  fetching,
  statusCode,
  error,
  success,
  currencySign,
  dispatchResetSession,
  dispatchResetReportsErrorAction,
  dispatchResetReportsSuccessAction,
  dispatchGetReceiptAndPaymentReportAction,
  receiptAndPaymentData,
  dispatchResetReceiptAndPaymentReportAction,
}: AppProps) => {
  const clientCode = history?.location?.state?.client_code;
  const companyName = history?.location?.state?.company_name
    ? history?.location?.state?.company_name
    : clientCompanyName;
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [displayStartDate, setDisplayStartDate] = useState("");
  const [displayEndDate, setDisplayEndDate] = useState("");
  const [toggle, setToggle] = useState<boolean>(false);

  useEffect(() => {
    dispatchResetReportsErrorAction();
    dispatchResetReportsSuccessAction();
    dispatchResetReceiptAndPaymentReportAction();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (displayEndDate != endDate || startDate != displayStartDate) {
      setDisplayStartDate(formatDate(startDate));
      setDisplayEndDate(formatDate(endDate));
    }
    //eslint-disable-next-line
  }, [receiptAndPaymentData]);

  const handleStartDateChange = (date: string) => {
    const value = handleDate(date);
    setStartDate(value);
  };

  const handleEndDateChange = (date: string) => {
    const value = handleDate(date);
    setEndDate(value);
  };

  const handleSubmitData = () => {
    dispatchResetReportsSuccessAction();
    dispatchResetReportsErrorAction();
    if (token) {
      let finalData = {
        token,
        start_date: startDate ? reverseDateFormat(startDate) : "",
        end_date: endDate ? reverseDateFormat(endDate) : "",
        client_code: clientCode,
      };
      dispatchGetReceiptAndPaymentReportAction(finalData);
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetReportsErrorAction();
            }}
          />
        );
      }
    }

    return false;
  };


  return (
    <>
      <div className="col-md-6">
        <CommonHeader
          title="Receipts & Payment Account"
          company_name={companyName}
          client_code={clientCode}
        />
      </div>
      <div className="new-table-card mt-4">
        <div className="ml-4 pt-3">
          <ReceiptAndPaymentHeader
            setToggle={setToggle}
            toggle={toggle}
            startDate={startDate}
            endDate={endDate}
            handleStartDateChange={handleStartDateChange}
            handleEndDateChange={handleEndDateChange}
            handleSubmitData={handleSubmitData}
          />
        </div>
        <hr className="mt-4 mb-4" style={{ width: "97%" }} />
        {!fetching &&
        receiptAndPaymentData?.receipt?.total_opening_balance === 0 &&
        receiptAndPaymentData?.payment?.total_closing_balance === 0 &&
        receiptAndPaymentData?.receipt?.receipt_total === 0 &&
        receiptAndPaymentData?.payment?.payment_total === 0 ? (
          <EmptyListPage
            title={`No Receipts & Payments Account Found!`}
            text={`Choose a date to get Receipts & Payments Account.`}
            image={BalanceSheetImage}
            imageWidth="30%"
          />
        ) : (
          <>
            <div className="d-flex">
              <div className="d-flex flex-column mb-3" style={{ flex: "22" }}>
                <h3 className="text-center">{clientCompanyName}</h3>
                <h5 className="text-center">Receipts & Payments Account</h5>
                <div className="d-flex justify-content-center">
                  <h6 className="text-center mr-4">
                    Start Date:{" "}
                    {fetching ? (
                      <span>
                        <SkeltonElement type="title" />
                      </span>
                    ) : (
                      <span className="font-weight-bolder">
                        {displayStartDate}
                      </span>
                    )}
                  </h6>
                  <h6 className="text-center">
                    End Date:{" "}
                    {fetching ? (
                      <span>
                        <SkeltonElement type="title" />
                      </span>
                    ) : (
                      <span className="font-weight-bolder">
                        {displayEndDate}
                      </span>
                    )}
                  </h6>
                </div>
              </div>
             
            </div>
            <div
              style={{ display: "flex", gap: "3%", justifyContent: "center" }}
            >
              <div style={{ width: "46%" }}>
                <h5>Receipts </h5>
                <ReceiptAndPaymentReceiptTable
                  fetching={fetching}
                  tableHeaders={RECEIPT_AND_PAYMENT_HEADERS}
                  data={receiptAndPaymentData}
                  currencySign={currencySign}
                />
              </div>
              <div style={{ width: "46%" }}>
                <h5>Payments</h5>
                <ReceiptAndPaymentPaymentTable
                  fetching={fetching}
                  tableHeaders={RECEIPT_AND_PAYMENT_HEADERS}
                  data={receiptAndPaymentData}
                  currencySign={currencySign}
                />
              </div>
            </div>
          </>
        )}
      </div>
      {handleErrorModal()}
      <Toaster />
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  clientCompanyName: state.auth.companyName,
  token: state.auth.token,
  fetching: state.reports.fetching,
  error: state.reports.error,
  statusCode: state.reports.statusCode,
  success: state.reports.success,
  currencySign: state.auth.currencySign,
  receiptAndPaymentData: state.reports.receiptAndPayment,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetReportsErrorAction: () => dispatch(resetReportsError()),
  dispatchResetReportsSuccessAction: () => dispatch(resetReportsSuccess()),
  dispatchGetReceiptAndPaymentReportAction: (
    data: GetReceiptAndPaymentReportsPayloadType
  ) => dispatch(getReceiptAndPaymentReportAction(data)),
  dispatchResetReceiptAndPaymentReportAction: () =>
    dispatch(resetReceiptAndPayment()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReceiptAndPayment);
